import React, { useEffect, useState } from "react";
import axios from "../../../../axiosConfig";
import "./ModalSorteioEvento.css";
import { Gift } from "lucide-react";

const ModalSorteioEvento = ({ slug, onClose }) => {
  const [contador, setContador] = useState(5);
  const [mostrarPremio, setMostrarPremio] = useState(false);
  const [nomePremio, setNomePremio] = useState("");
  const [premioFisico, setPremioFisico] = useState(null);
  const [erro, setErro] = useState("");
  const [loading, setLoading] = useState(true);

  const cliente_id = JSON.parse(localStorage.getItem("usuario"))?.id;

  useEffect(() => {
    const carregarResultado = async () => {
      let resultado = null;
      try {
        const raw = localStorage.getItem("sorteio_resultado");
        resultado = raw ? JSON.parse(raw) : null;
      } catch (err) {
        console.warn("⚠️ Erro ao interpretar sorteio_resultado:", err);
      }

      // 🔁 Fallback via API
      if (!resultado) {
        try {
          const res = await axios.get(`/evento/resultado/${slug}`, {
            headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
          });

          const resPremio = res.data?.premio;
          if (typeof resPremio === "string") {
            resultado = resPremio;
          } else if (resPremio?.nome) {
            resultado = resPremio.nome;
          }
        } catch (err) {
          console.error("❌ Falha ao carregar resultado do sorteio via API:", err);
        }
      }

      if (!resultado) {
        setErro("❌ Não foi possível carregar o resultado do sorteio.");
        return;
      }

      if (resultado.startsWith("premio_fisico_")) {
        const id = resultado.split("_").pop();
        try {
          const { data } = await axios.get(`/premios/${id}`);
          setNomePremio(data?.nome || "Prêmio físico");
          setPremioFisico(data);
        } catch (err) {
          console.warn("❌ Erro ao buscar imagem do prêmio físico:", err);
          setNomePremio("Prêmio físico");
        }
      } else {
        setNomePremio(resultado);
      }

      iniciarContagem();
      localStorage.setItem("participou_evento", "sim");
    };

    carregarResultado().finally(() => setLoading(false));
  }, [slug, cliente_id]);

  const iniciarContagem = () => {
    let intervalo = setInterval(() => {
      setContador((prev) => {
        if (prev <= 1) {
          clearInterval(intervalo);
          setMostrarPremio(true);
          return 0;
        }
        return prev - 1;
      });
    }, 800);
  };

  if (erro) {
    return (
      <div className="modal-sorteio-overlay">
        <div className="modal-sorteio-box">
          <p className="erro">{erro}</p>
          <button onClick={onClose}>Fechar</button>
        </div>
      </div>
    );
  }

  return (
    <div className="modal-sorteio-overlay">
      <div className="modal-sorteio-box animate">
        {!mostrarPremio ? (
          <div className="sorteio-contador">
            <p className="preparando">Preparando seu prêmio...</p>
            <div className="numero-contador">{contador}</div>
          </div>
        ) : (
          <div className="premio-revelado animate-premio">
            <h1 className="sorteio-titulo">
              <Gift size={28} style={{ marginRight: 8 }} /> Parabéns!
            </h1>
            <p className="sorteio-descricao">Você ganhou:</p>
            <h2 className="sorteio-premio">{nomePremio}</h2>

            {premioFisico?.imagem && (
              <img
                src={premioFisico.imagem}
                alt={premioFisico.nome}
                className="imagem-premio-fisico"
              />
            )}

            <p className="sorteio-obs">O prêmio será enviado conforme as regras do evento.</p>

            <button
              className="btn-ver-status"
              onClick={() => {
                onClose();
                window.location.href = "/painel-cliente/eventos";
              }}
            >
              Ver meu status na área de eventos
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ModalSorteioEvento;
